import React, { useEffect, useState } from 'react'
import { DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material'
import { CloseIcon } from '../../helper/Icons'
import { Button, ErrorMessage, Input, Loader, Select, UploadImage } from '../../components/Common'
import { useGetserviceDepartmentDropdownQuery } from '../../services/ServiceDepartment'
import { useMessage } from '../../components/Common/Message/MessageContext'
import { useAddNewSubServiceMutation, useUpdateSubServiceMutation } from '../../services/SubServices'

const AddSubService = ({ handleClose, modalOpen }) => {
    const { showMessage } = useMessage();

    const [name, setName] = useState('');
    const [slug, setSlug] = useState('');
    const [selectService, setSelectService] = useState('');
    const [nameErrorMessage, setNameErrorMessage] = useState('');
    const [serviceErrorMessage, setServiceErrorMessage] = useState('');
    const [files, setFiles] = useState([]);
    const [filesErrorMessage, setFilesErrorMessage] = useState('');
    const handleChange = (e) => {
        setSelectService(e.target.value);
    }
    const { data, error, isLoading } = useGetserviceDepartmentDropdownQuery();
    const [addSubService, { isLoading: isAdding }] = useAddNewSubServiceMutation();
    const [updateSubService, { isLoading: isUpdating }] = useUpdateSubServiceMutation();
    const serviceList = data?.data;

    const handleSubmit = async () => {
        // Reset error messages
        setNameErrorMessage('');
        setServiceErrorMessage('');
        setFilesErrorMessage('');

        // Validation for mandatory fields
        let hasError = false;
        if (!name) {
            setNameErrorMessage('Name is a mandatory field.');
            hasError = true;
        }
        if (!selectService) {
            setServiceErrorMessage('Service is a mandatory field.');
            hasError = true;
        }
        if (files.length === 0) {
            setFilesErrorMessage('Image is a mandatory field.');
            hasError = true;
        }

        if (hasError) {
            return;
        }

        const formData = new FormData();
        formData.append('serviceDepartmentId', selectService);
        formData.append('subServiceName', name);
        formData.append('image', files);

        try {
            let response;
            if (modalOpen.isEdit) {
                response = await updateSubService({ id: modalOpen.id, body: formData });
            } else {
                response = await addSubService(formData);
            }

            const { status, message } = response?.data || {};

            if (status) {
                showMessage('success', message);
            } else {
                showMessage('error', message);
            }
        } catch (error) {
            showMessage('error', 'An error occurred while processing your request.');
        } finally {
            handleClose();
        }
    };

    useEffect(() => {
        if (modalOpen.data) {
            setName(modalOpen?.data?.subServiceName);
            setSelectService(modalOpen?.data?.serviceDepartmentId);
            setFiles(modalOpen?.data?.image || '');
            setSlug(modalOpen?.data?.slug || '');
        }
    }, [modalOpen?.data]);

    return (
        <>
            <Loader open={isAdding || isUpdating} />
            <DialogTitle sx={{ m: 0, p: 2 }} id="Common_modal">
                {modalOpen.isEdit ? 'Edit' : "Add"} Sub Service
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <Grid container gap={2} width={{ sm: '400px' }} paddingY={1}>
                    <Grid item xs={12}>
                        <Typography fontSize={{ xs: '12px', sm: '13px' }} fontWeight={500} mb={'2px'}>Sub Service Image</Typography>
                        <UploadImage files={files} setFiles={setFiles} />
                        <ErrorMessage message={filesErrorMessage} />
                    </Grid>
                    <Grid item xs={12}>
                        <Select selectList={isLoading ? [] : serviceList} value={selectService} onChange={handleChange} labelinput='Category' selectHead='Select Category' />
                        <ErrorMessage message={serviceErrorMessage} />
                    </Grid>
                    <Grid item xs={12}>
                        <Input labelinput='Name' value={name} onChange={(e) => setName(e.target.value)} />
                        <ErrorMessage message={nameErrorMessage} />
                    </Grid>
                    {modalOpen.isEdit && slug && (
                        <Grid item xs={12}>
                            <Typography fontSize={{ xs: '12px', sm: '13px' }} fontWeight={500} mb={'2px'}>
                                URL Slug (auto-generated)
                            </Typography>
                            <input
                                type="text"
                                value={slug}
                                readOnly
                                disabled
                                style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    background: '#f5f5f5',
                                    color: '#888',
                                    fontSize: '13px',
                                    cursor: 'not-allowed',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button buttonName={'Cancel'} size='small' color='white' onClick={handleClose} />
                <Button buttonName={modalOpen.isEdit ? 'Update' : 'Save'} size='small' onClick={handleSubmit} />
            </DialogActions>
        </>
    )
}

export default AddSubService